import React, {useEffect, useRef} from "react";
import {Tab, Tabs} from "@mui/material";
import styles from "../MovieCard/MovieCard.module.css";
import {MovieCard} from "../../index";
import {IData} from "../types";
import {IContentContext} from "../../../store/player/playerSlice";
import {CARD_SLIDER_LOAD_MORE_SCROLL_RATIO} from "../../../constants";
import clsx from "clsx";

interface IProps {
    data?: IData[];
    top10?: boolean
    isProgram?: boolean
    contentContext?: IContentContext | null;
    hasMore?: boolean;
    isLoadingMore?: boolean;
    onLoadMore?: () => void;
    isSportsCard?: boolean;
}

const CardSlider: React.FC<IProps> = (props) => {
    const {data, isProgram, top10, contentContext, hasMore = false, isLoadingMore = false, onLoadMore, isSportsCard} = props;
    const tabsRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const scroller = tabsRef.current?.querySelector(".MuiTabs-scroller");
        if (!scroller) return;

        const handleScroll = () => {
            if (!hasMore || isLoadingMore || !onLoadMore) return;

            const {scrollLeft, scrollWidth, clientWidth} = scroller;
            const maxScrollLeft = scrollWidth - clientWidth;
            const scrollRatio = maxScrollLeft > 0 ? scrollLeft / maxScrollLeft : 1;
            if (scrollRatio >= CARD_SLIDER_LOAD_MORE_SCROLL_RATIO) onLoadMore();
        };

        scroller.addEventListener("scroll", handleScroll);
        return () => {
            scroller.removeEventListener("scroll", handleScroll);
        };
    }, [hasMore, isLoadingMore, onLoadMore]);

    return (
        <Tabs
            ref={tabsRef}
            className={styles.tabs}
            value={false}
            variant="scrollable"
            aria-label="scrollable force tabs example"
            indicatorColor={"secondary"}
        >
            {data?.map((e: IData, index) => (
                <Tab
                    key={e.id}
                    className={clsx(styles.tab, isSportsCard && styles.tabSports)}
                    label={
                        <MovieCard
                            data={e}
                            isProgram={isProgram}
                            rank={top10 ? index + 1 : null}
                            contentContext={contentContext}
                            isSportsCard={isSportsCard}
                        />
                    }
                />
            ))}
        </Tabs>

    );
};

export default CardSlider;
